module.exports = __webpack_public_path__ + "static/media/advanced.20f57372.png";